(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    



  document.addEventListener('DOMContentLoaded', function() {
    // Stebime visus "Add to Cart" mygtukus
    document.body.addEventListener('click', async function(event) {
      const button = event.target.closest('.add-to-cart-btn');
      if (!button) return;

      // Surandame produkto ID ir pavadinimą
      const form = button.closest('form');
      if (!form) return;

      const formData = new FormData(form);
      const productId = formData.get('id');

      try {
        // Paimame papildomus produkto duomenis iš Shopify AJAX API
        const response = await fetch(`/products/${window.location.pathname.split('/products/')[1]}.js`);
        const productData = await response.json();

        // Siunčiame įvykį į Klaviyo
        if (window._learnq) {
          _learnq.push(['track', 'Added to Cart', {
            ProductID: productId,
            ProductName: productData.title,
            ProductURL: window.location.href,
            ProductPrice: productData.price / 100,
            ProductImage: productData.images?.[0] || null
          }]);
          console.log('✅ Klaviyo "Added to Cart" event sent successfully');
        }
      } catch (error) {
        console.error('⚠️ Error tracking Klaviyo Added to Cart:', error);
      }
    });
  });


  jQuery(document).ready(function($)  {
    $('form').on('submit', function (e) {
      $('.add-to-cart-btn').addClass('loading')
    })

    document.addEventListener('kaching-cart:open',   () => $('.add-to-cart-btn').removeClass('loading'));
  })


  document.addEventListener('DOMContentLoaded', () => {
    const qsa = (s, c = document) => Array.from(c.querySelectorAll(s));

    const nodes = qsa('.receive-date');
    if (!nodes.length) return;

    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

    /**
     * Adds business days (skipping Saturday & Sunday)
     * @param {Date} date
     * @param {number} daysToAdd
     * @returns {Date}
     */
    const addBusinessDays = (date, daysToAdd) => {
      const result = new Date(date);

      // If today is weekend, start from Monday
      const currentDay = result.getDay();
      if (currentDay === 0) {
        // Sunday → move to Monday
        result.setDate(result.getDate() + 1);
      } else if (currentDay === 6) {
        // Saturday → move to Monday
        result.setDate(result.getDate() + 2);
      }

      let added = 0;
      while (added < daysToAdd) {
        result.setDate(result.getDate() + 1);
        const day = result.getDay();
        if (day !== 0 && day !== 6) {
          added++;
        }
      }
      return result;
    };

    nodes.forEach((node) => {
      const daysAttr = node.getAttribute('data-receive-days');
      const addDays = parseInt(daysAttr, 10);
      if (isNaN(addDays)) return;

      const today = new Date();
      today.setHours(12, 0, 0, 0);

      const targetDate = addBusinessDays(today, addDays);

      const day = targetDate.getDate();
      const monthAbbr = months[targetDate.getMonth()];
      const year = targetDate.getFullYear();
      const dayName = weekdays[targetDate.getDay()];

      node.textContent = `${monthAbbr} ${day}, ${year}`;

      const dayEl = node.closest('li').querySelector('.receive-day-name');
      if (dayEl) {
        dayEl.textContent = dayName;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
